"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acquappesa": {
    "7052b489": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "chiusoli": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f43b603": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "martino": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c94710fb": [{
      "hkey": "00217366",
      "slug": "pantana-santa-rosalia-macchia",
      "name": "Pantana-Santa Rosalia-Macchia",
      "primary": true,
      "skipSearch": false
    }],
    "pantana": [{
      "hkey": "00217366",
      "slug": "pantana-santa-rosalia-macchia",
      "name": "Pantana-Santa Rosalia-Macchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fe1c1b55": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "piano-della-mola": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58bbbca1": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "policaretto": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "482461d8": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "rii": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35993ace": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "riuncia": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b64bdc55": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "san-iorio": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "668ffcc5": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "scarpa": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2fa013f7": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "tiraso": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b78ad74a": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "skipSearch": false
    }],
    "torricelle": [{
      "hkey": "66eda306",
      "slug": "acquappesa",
      "name": "Acquappesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;